import {Money} from '../../../../../../../common/api';

export class OutgoingTransferDetail {
    id: number;
    bank_reference: string;
    payment_state: string;
    create_time: string;
    sender?: SenderPaymentInfo;
    source_amount: Money;
    recipient?: RecipientPaymentInfo;
    dest_amount: Money;
    rate: number;
    fee_amount: Money;
    narrative: string;
    ownerProfile?: Profile;
    editable?: boolean;
    aml_reasons: string[];
}

export class SenderPaymentInfo {
    name: string;
    account_number: string;
    account_name: string;
    address: BeneficiaryAddress;
}

export class RecipientPaymentInfo {
    account_number: string;
    iban: string;
    name: string;
    address: BeneficiaryAddress;
    bank_name: string;
    bank_address: string;
    bank_country_id: number;
    swift_bic: string;
    beneficiary_country_id: number;
    beneficiary_city: string;
}

export class Profile {
    id: number;
    name: string;
    email: string;
    introducer: string;
}

export class BeneficiaryAddress {
    countryCode: string;
    city: string;
    streetAddress: string;
    zipCode: string;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/api/entity/transfer/detail/outgoing.transfer.detail.i.ts